import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../state/reducers/global";
import ModalInsert from "../../components/ModalInsert";
import GenericConfirmInsert from "../../components/GenericConfirmInsert";
import { cancelSale } from "../../../state/reducers/claimDetailsVendor";
import { clearVehicleRegRequest } from "../../../state/reducers/regSearch";
import { setBucketType } from "../../../state/reducers/toolbar";
import { setActiveConfirmModalOptions } from "../../../state/reducers/vendor-vehicle/genericActiveState";
import { setActiveConfirmModalOptionsClaims } from "../../../state/reducers/claimDetailsVendor";
import { vehicleMenuAction } from "../../../state/reducers/vendor-vehicle/vehicleDetails";
import { useNavigate } from "react-router";

const VendorCancelSaleDecision = ({ formData, buyerName }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const resultType = useSelector((state) => state.global.results.resultType);

  const refreshResults = resultType === "claimsVendor";

  const onCancelSale = () => {
    if (formData.claimId) {
      dispatch(cancelSale(formData, refreshResults, navigate));
      const type = "vehicle";
      const data = {
        action: "cancel-sale",
        vehicleReference: formData.vehicleId,
      };
      dispatch(setActiveConfirmModalOptionsClaims(type, data));
      dispatch(setBucketType("all"));
      dispatch(clearVehicleRegRequest());
    } else if (formData.vehicleId) {
      const type = "vehicle";
      const data = {
        vehicleReference: formData.vehicleId,
        action: "cancel-sale",
      };
      dispatch(setActiveConfirmModalOptions(type, data));
      dispatch(
        vehicleMenuAction({
          actionType: data.action,
          vehicleId: data.vehicleReference,
          actionData: formData,
        })
      );
    }
  };

  const onCancel = () => {
    dispatch(closeModal());
  };

  const bodyTextDecider = buyerName ? `You are about to cancel this sale for ${buyerName}, are you sure?` : "Are you sure you want to cancel this sale?";

  return (
    <Fragment>
      <ModalInsert>
        <GenericConfirmInsert
          headerText="Are you sure?"
          bodyText={bodyTextDecider}
          onCancel={onCancel}
          onConfirm={onCancelSale}
        />
      </ModalInsert>
    </Fragment>
  );
};

export default VendorCancelSaleDecision;
